import { render } from "./CommentInformationBar.vue?vue&type=template&id=2b944641&scoped=true"
import script from "./CommentInformationBar.vue?vue&type=script&lang=js"
export * from "./CommentInformationBar.vue?vue&type=script&lang=js"

import "./CommentInformationBar.vue?vue&type=style&index=0&id=2b944641&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b944641"]])

export default __exports__